import { FeedbackTroublesModel } from "../../models/FeedbackTroubles/FeedbackTroublesModel";


export const feedbackTroublesCreator = data => {
    return data && new FeedbackTroublesModel({
        sections: data.sections,
        list: data.list,
    })
}
